import { gql } from '@apollo/client'

export const OPERATION_TRAFFIC = gql`
  query Traffic($sfIds: [ID], $startsAt: String, $endsAt: String, $scale: String, $viewType: String) {
    traffic(sf_ids: $sfIds, starts_at: $startsAt, ends_at: $endsAt, scale: $scale, group_by: $viewType) {
      graph {
        date
        scale
        is_estimated
        average_per_device_type
        average_per_device_ssid
        average_per_device_site
        networks {
          name
          active_users
          upload
          download
        }
        ssids {
          name
          network_name
          active_users
          upload
          download
        }
        sites {
          name
          site_id
          active_users
          upload
          download
        }
      }
      ssids {
        name
        network_name
        active_users
        upload
        download
      }
      sites {
        name
        site_id
        active_users
        upload
        download
      }
      connected_devices
      average_connected_devices
      network_private_consumed
      network_guest_consumed
      network_other_consumed
    }
  }
`

export const OPERATION_TRAFFIC_EVOLUTION = gql`
  query TrafficEvolution($sfIds: [ID], $startsAt: String, $endsAt: String) {
    trafficNetworkEvolution(sf_ids: $sfIds, starts_at: $startsAt, ends_at: $endsAt) {
      date
      consumption_current_year
      consumption_past_year
      percentage
    }
    trafficActiveUsersEvolution(sf_ids: $sfIds, starts_at: $startsAt, ends_at: $endsAt) {
      date
      count_current_year
      count_past_year
      percentage
    }
  }
`

export const FIND_COUPON_DISTRIBUTION = gql`
  query FindCouponDistribution($createdAtStart: String, $createdAtEnd: String, $offerNames: String, $siteIds: [String!]) {
    findCouponDistribution(created_at_start: $createdAtStart, created_at_end: $createdAtEnd, offerNames: $offerNames, siteIds: $siteIds) {
      couponMonthlyPrice {
        startDate
        endDate
        count
      }
      couponMonthlyUsage {
        startDate
        endDate
        count
      }
      couponOffers {
        name
        count
      }
      couponSites {
        name
        count
      }
      globalPrice
      globalAveragePrice
    }
  }
`

export const OPERATION_FIND_USERS_LANGUAGE = gql`
  query portalUsersLanguages (
    $site_sf_ids: [ID]
    $range: String
    $created_at_start: String
    $created_at_end: String
  ) {
    usersLanguage: portalUsersLanguages(
      site_sf_ids: $site_sf_ids
      range: $range
      created_at_start: $created_at_start
      created_at_end: $created_at_end
    ) {
      key
      percentage
      count
    }
  }
`

const OPERATION_FIND_TRAFFIC_BY_DEVICE = gql`
  query portalUsersTrafficByDevice(
    $site_sf_ids: [ID]
    $range: String
    $created_at_start: String
    $created_at_end: String
  ) {
    trafficByDevice: portalUsersTrafficByDevice(
      site_sf_ids: $site_sf_ids
      range: $range
      created_at_start: $created_at_start
      created_at_end: $created_at_end
    ) {
      key
      percentage
      count
    }
  }
`

export default OPERATION_FIND_TRAFFIC_BY_DEVICE